import React from "react";

const ExportIcon = ({ className }) => (
  <svg
    className={className}
    width="25"
    height="24"
    viewBox="0 0 25 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.4688 22.9093C24.4688 23.5118 23.9804 24.0002 23.3778 24.0002H1.55966C0.957172 24.0002 0.46875 23.5118 0.46875 22.9093C0.46875 22.3068 0.957172 21.8184 1.55966 21.8184H23.3778C23.9804 21.8184 24.4688 22.3068 24.4688 22.9093Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8977 19.2961C13.0776 20.0068 11.8599 20.0068 11.0397 19.2961L5.7824 14.7397C4.25612 13.4169 5.19162 10.9091 7.21134 10.9091H9.196V2.18182C9.196 0.976833 10.1728 0 11.3778 0H13.5596C14.7646 0 15.7414 0.976833 15.7414 2.18182V10.9091H17.7261C19.7458 10.9091 20.6813 13.4169 19.155 14.7397L13.8977 19.2961ZM11.7543 17.0281C12.1642 17.3834 12.7732 17.3834 13.1832 17.0281L17.7261 13.0909H15.196C14.2923 13.0909 13.5596 12.3583 13.5596 11.4545V2.18182H11.3778V11.4545C11.3778 12.3583 10.6452 13.0909 9.74145 13.0909H7.21134L11.7543 17.0281Z"
    />
  </svg>
);

export default ExportIcon;
